/*
 * Copyright (c) 2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Card, CardBody } from "reactstrap";
import SplitField from "../../provisioning/elements/SplitField";
import { SummaryLabel } from "../../provisioning/elements/ReviewLabels";
import { secondsToTimeStringSession, unixEpochToString } from "../../util/DateTime";

const GuestProfileUserInfo = ({
  guest
}) => {

  // constants
  const gdprRejectedText = "Removed due to GDPR";

  // helpers
  const convertPhoneNumber = (phoneNumber) => {
    // validate
    if (guest.gdprAccepted === 0) {
      return gdprRejectedText;
    }

    if (!phoneNumber) {
      return null;
    }

    if (phoneNumber === gdprRejectedText) { 
      return phoneNumber;
    }

    // check for 10 digits
    if (phoneNumber.length <= 10) {
      return phoneNumber;
    }

    // add '+' if needed
    if (phoneNumber[0] !== "+") {
      phoneNumber = "+" + phoneNumber;
    }

    // split country code
    return `${phoneNumber.slice(0, -10)} ${phoneNumber.slice(-10)}`;
  };

  const processValue = (value) => {
    if (guest.gdprAccepted === 0) {
      return gdprRejectedText;
    }

    return value;
  }

  // styles
  const smoothTransitionStyle = {
    overflow: "hidden",
    transition: "all 0.6s ease-in-out"
  };

  const email = processValue(guest.email);
  const visits = guest.visits;
  const phoneNumber = convertPhoneNumber(guest.phoneNumber);
  const lastLogin = unixEpochToString(guest.lastLogin);
  const averageVisit = secondsToTimeStringSession(guest.averageVisitDuration);
  const totalVisit = secondsToTimeStringSession(guest.totalVisitDuration);
  const guestDevice = processValue(guest.guestDevice);
  const language = guest.userLanguage;
  const customTextField = processValue(guest.customTextField);

  return (
    <Card className={guest ? "ms-1 flex-40" : "flex-0"} style={smoothTransitionStyle}>
      {guest && (        
        <CardBody className="d-flex flex-column align-items-start">
          <SplitField className="w-100">
            <SummaryLabel title="Email" value={email} />
            <SummaryLabel title="Visits" value={visits} />
          </SplitField>
          <SplitField className="w-100">
            <SummaryLabel title="Phone Number" value={phoneNumber} />
            <SummaryLabel title="Total Visit Duration" value={totalVisit} />
          </SplitField>
          <SplitField className="w-100">
            <SummaryLabel title="Last Login" value={lastLogin} />
            <SummaryLabel title="Average Visit Duration" value={averageVisit} />
          </SplitField>
          <SplitField className="w-100">
            <SummaryLabel title="Device" value={guestDevice}/>
            <SummaryLabel title="Language" value={language} />
          </SplitField>
          <div className="py-1 w-100">
            <SummaryLabel title="Custom Text" value={customTextField}/>
          </div>
          <hr className="w-100" />
        </CardBody>
      )}
    </Card>
  );
};

export default GuestProfileUserInfo;